import { render } from "./StockTrade.vue?vue&type=template&id=6ad5a836&scoped=true"
import script from "./StockTrade.vue?vue&type=script&lang=js"
export * from "./StockTrade.vue?vue&type=script&lang=js"

import "./StockTrade.vue?vue&type=style&index=0&id=6ad5a836&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad5a836"]])

export default __exports__